var _rect, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgNum4Icon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2,
    width: 96,
    height: 96,
    rx: 48,
    fill: "#fff",
    stroke: "red",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "bevel",
    strokeDasharray: "0.5 4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M64.004 53.907v6.005H58.73v8.614h-6.474v-8.614h-17.49v-5.17L46.67 31.98h6.735L42.232 53.907h10.024V45.45h6.474v8.458h5.274z",
    stroke: "red",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "bevel",
    strokeDasharray: "0.5 4"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTAwIiBoZWlnaHQ9IjEwMCIgdmlld0JveD0iMCAwIDEwMCAxMDAiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+DQo8cmVjdCB4PSIyIiB5PSIyIiB3aWR0aD0iOTYiIGhlaWdodD0iOTYiIHJ4PSI0OCIgZmlsbD0id2hpdGUiIHN0cm9rZT0iI0ZGMDAwMCIgc3Ryb2tlLXdpZHRoPSIyLjUiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJiZXZlbCIgc3Ryb2tlLWRhc2hhcnJheT0iMC41IDQiLz4NCjxwYXRoIGQ9Ik02NC4wMDM1IDUzLjkwNzRWNTkuOTExNkg1OC43MzAzVjY4LjUyNjRINTIuMjU2MlY1OS45MTE2SDM0Ljc2NTZWNTQuNzQyOEw0Ni42Njk2IDMxLjk3OUg1My40MDQ4TDQyLjIzMTcgNTMuOTA3NEg1Mi4yNTYyVjQ1LjQ0OTNINTguNzMwM1Y1My45MDc0SDY0LjAwMzVaIiBzdHJva2U9IiNGRjAwMDAiIHN0cm9rZS13aWR0aD0iMi41IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0iYmV2ZWwiIHN0cm9rZS1kYXNoYXJyYXk9IjAuNSA0Ii8+DQo8L3N2Zz4NCg==";
export { SvgNum4Icon as ReactComponent };